import type { ComponentProps, ReactElement } from 'react';

import { Tooltip } from '@scaleaq/scaleui';

import { StyledCameraStreamControlButton } from './cameraStreamControlButton/cameraStreamControlButton.styles.ts';

type CameraStreamControlButtonProps = {
  disabled?: boolean;
  hidden?: boolean;
  icon: ReactElement;
  label: string;
  onClick: () => void;
  tooltipPlacement?: ComponentProps<typeof Tooltip>['placement'];
};

/** Hover control on the camera widget: circular icon button with a tooltip. */
export const CameraStreamControlButton = ({
  disabled,
  hidden,
  icon,
  label,
  onClick,
  tooltipPlacement = 'top-end',
}: CameraStreamControlButtonProps) => (
  <Tooltip tooltip={label} placement={tooltipPlacement}>
    <StyledCameraStreamControlButton
      aria-label={label}
      className='keep-background'
      disabled={disabled}
      hidden={hidden}
      variant='soft'
      size='large'
      Icon={icon}
      onClick={event => {
        event.stopPropagation();
        onClick();
      }}
    />
  </Tooltip>
);
